import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track7CBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track7CBlue" transform="translate(1540.500000, 1189.000000)" className="track">
		<path
			d="M96.7100864,0.270136059 L95.7619313,8.53574143 C95.5752107,10.1634909 95.7913032,11.8121856 96.391205,13.3368333 L109.087605,45.6046796 C115.244596,61.2526472 114.552514,78.7661892 107.179929,93.8795088 L91.9987208,125 L91.9987208,125 M87.5858895,133.204332 L87.0408885,134.238722 C82.0955985,143.62468 72.359058,149.5 61.75,149.5 C51.2696184,149.5 41.7818037,143.300069 37.5736294,133.701649 L0,48"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeWidth={tracksWidth}
			strokeLinecap="round"/>
		<TrackArrow transform="translate(93.325562, 122.132693) rotate(-418.000000) translate(-93.325562, -122.132693) "
								points="97.3255623 130.132693 89.3255623 122.132693 97.3255623 114.132693"
								strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track7CBlue')}
			coords="91.998721, 67.000000"
			text="7C"
			textCoordsX="11.0693359"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

Track7CBlue.propTypes = trackPropTypes;

export default Track7CBlue;
